module.exports = __webpack_public_path__ + "media/luxury-2026/timber-dining-f2f54834.jpg";